import Vue from "vue"
import "./plugins/fontawesome"
import "./plugins/bootstrap-vue"
import App from './App.vue'
import Vuex from "vuex"
Vue.use(Vuex);

import router from "./router";
import store from "./store";
import axios from "axios";
import "./plugins/axios";
import "./config.js";

Vue.config.productionTip = false

import VueAWN from "vue-awesome-notifications";
let options = {
    position: "bottom-right",
    labels: {
        info: "Information",
        success: "Succès",
        warning: "Attention",
        alert: "Erreur",
        async: "Chargement...",
        confirm: "Attention",
        confirmOk: "Valider",
        confirmCancel: "Annuler",
    },
};
Vue.use(VueAWN, options);

import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";

const datepickerOptions = {
    days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    daysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    monthNames: [
        'Janvier',
        'Fevrier',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
    ],
    colors: {
        selected: '#00a699',
        inRange: '#66e2da',
        selectedText: '#fff',
        text: '#565a5c',
        inRangeBorder: '#33dacd',
        disabled: '#fff',
        hoveredInRange: '#67f6ee'
    },
    texts: {
        apply: 'Appliquer',
        cancel: 'Annuler',
        keyboardShortcuts: 'Raccourcis',
    },
    keyboardShortcuts: [
        {
            symbol: '↵',
            label: 'Sélectionnez la date en surbrillance',
            symbolDescription: 'Touche entrée'
        },
        {
            symbol: '←/→',
            label: 'Déplacement d\' un jour à gauche ou à droite',
            symbolDescription: 'Touche directionnel gauche ou droite'
        },
        {
            symbol: '↑/↓',
            label: 'Déplacemene d\'une semaine en haut ou en bas',
            symbolDescription: 'touche directionnel haut ou bas'
        },
        {
            symbol: 'PgUp/PgDn',
            label: 'Changer les mois',
            symbolDescription: 'touche page suivante, précédente'
        },
        {
            symbol: 'Home/End',
            label: 'Aller au dernier jour d\'une semaine',
            symbolDescription: 'touche Fin'
        },
        {
            symbol: 'Esc',
            label: 'Fermer le panneau',
            symbolDescription: 'Touche échap'
        },
        {
            symbol: '?',
            label: 'Ouvrir le panneau',
            symbolDescription: 'Raccourcis'
        }
    ],
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

const DEFAULT_TITLE = "Gestion ODP";
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    // On redirige sur l'utilisateur n'est pas connecté
    if (requiresAuth && !store.getters["Authentification/isAuthenticated"]) {
        // next("/login");
        next();
    }

    // Contrôle sur l'utilisateur connecté
    else if (store.getters["Authentification/isAuthenticated"] && !store.getters["Authentification/isUserConnected"]) {
        Vue.axios.get(window.urlapi_login + "user").then((response) => {
            if (typeof response.data.data.id !== "undefined") {
                store.dispatch("Authentification/setUserConnected", response.data.data);
                next();
            } else
                next();
        });
    }

    next();
});

window.Event = new Vue();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");